import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import './ReviewsPage.css'

export const ReviewModel = ({ open, handleClose, handleSubmit, title, children }) => {
  return (
    <Dialog open={open} onClose={handleClose} 
    className= "review-model">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions sx={{display:"flex", justifyContent:"flex-start", margin:"0px 20px 10px 20px", }}>
      <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            className='model-submit-btn'
          >
            Submit
          </Button>
        <Button onClick={handleClose} color="primary"
        className='model-cancel-btn'
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export const CloseReviewModel = ({open, handleClose, handleSubmit, title, children})=>{
  return (
    <Dialog open={open} onClose={handleClose} 
    className= "review-model">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions sx={{display:"flex", justifyContent:"flex-start", margin:"0px 20px 10px 20px", }}>
      <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            className='model-submit-btn'
          >
            Submit
          </Button>
        <Button onClick={handleClose} color="primary"
        className='model-cancel-btn'
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
